// Max value for GraphQL Int (32-bit signed integer)
export const GRAPHQL_INT_32_MAX = 2147483647;
